export default __webpack_public_path__ + "static/media/noimage3.247a07dd.png";